import styled from "styled-components";

export const StyledDescriptionLabel = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: row;
  gap: 10px;

  svg {
    height: 12px;
  }
`;
